import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import { type IGridCellRendererParams } from "commonComponents/utilities/AgGridReact/AgGridReact.types";
import { RFILink, type RFILinkResponse } from "commonComponents/utilities/RFIs/RFILink";

import "./columnRFI.less";

function columnRFIInternal(props: IGridCellRendererParams<RFILinkResponse>) {
    if (props.node.group) {
        return <>{props.value}</>;
    } else if (props.value) {
        return (
            <div className={cn("ag-col-rfi", props.className)}>
                <RFILink
                    id={props.value.id}
                    linkedType={props.value.linkedType}
                    builderId={props.value.builderId}
                    jobId={props.value.jobId}
                    rfiCount={props.value.rfiCount}
                />
            </div>
        );
    }
    return null;
}

export const columnRfi = memo(columnRFIInternal);
